import React from "react";
import ReactDOM from "react-dom";
import { App, AppProps } from "./ui/app";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";

interface RootProps extends AppProps {
  appInsightsConnectionString: string;
}

var appInsights: ApplicationInsights | null = null;

export function renderSpa(e: Element, props: RootProps) {
  if (appInsights == null) {
    appInsights = new ApplicationInsights({
      config: {
        connectionString: props.appInsightsConnectionString
          ? props.appInsightsConnectionString
          : "InstrumentationKey=e700106a-5dfa-4b9b-8bc4-003836200323;IngestionEndpoint=https://australiasoutheast-0.in.applicationinsights.azure.com/",
        enableAutoRouteTracking: true,
        disableFetchTracking: false,
        enableCorsCorrelation: true,
        enableRequestHeaderTracking: true,
        enableResponseHeaderTracking: true,
      },
    });
    appInsights.loadAppInsights();
    appInsights.trackPageView();
  }

  ReactDOM.render(
    <React.StrictMode>
      <App
        baseUrl={props.baseUrl || ""}
        clientId={props.clientId || ""}
        merchantCode={props.merchantCode || ""}
        securePaySrc={props.securePaySrc || ""}
      />
    </React.StrictMode>,
    e
  );
}
